const STATS = [
  { value: "2+", label: "Years Regional Expertise" },
  { value: "100%", label: "On-Time Site Completion" },
  { value: "7", label: "Core Heavy & Fine Services" },
  { value: "5-Star", label: "Client Satisfaction" },
];

export const Stats = () => {
  return (
    <section className="bg-[#F5A623]" data-testid="stats-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((stat) => (
            <div key={stat.label} className="text-center lg:text-left lg:border-l-2 lg:border-[#0C1827]/20 lg:pl-6 first:border-0 first:pl-0">
              <div className="font-display font-black text-3xl sm:text-4xl text-[#0C1827]">{stat.value}</div>
              <div className="mt-1 text-xs sm:text-sm font-semibold uppercase tracking-wider text-[#0C1827]/70">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
